export const SET_PRE_DEALS = 'SET_PRE_DEALS';

export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE';
